import React from "react";

const MaintenancePage = () => {
  const getSGTDate = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Singapore",
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(date);
  };

  const getSGTTime = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Singapore",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  const now = new Date();

  // Today 7:00 PM SGT
  const maintenanceStart = new Date(now);
  maintenanceStart.setHours(19, 0, 0, 0);

  // Tomorrow 12:00 PM SGT
  const maintenanceEnd = new Date(now);
  maintenanceEnd.setDate(maintenanceEnd.getDate() + 1);
  maintenanceEnd.setHours(12, 0, 0, 0);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "15px",
      }}
    >
      <div
        className="container"
        style={{
          textAlign: "center",
          background: "white",
          padding: "10px",
          borderRadius: "20px",
          maxWidth: "700px",
          width: "100%",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/565/565547.png"
          alt="Maintenance Icon"
          style={{
            width: "100px",
            marginBottom: "20px",
            opacity: "0.9",
          }}
        />

        <h1
          style={{
            marginBottom: "15px",
            fontSize: "30px",
            fontWeight: "700",
          }}
        >
          Scheduled Maintenance
        </h1>

        <p
          style={{
            fontSize: "17px",
            lineHeight: "1.6",
            color: "#444",
          }}
        >
          Dear Valued Partners,
        </p>

        <p
          style={{
            fontSize: "17px",
            lineHeight: "1.6",
            color: "#444",
          }}
        >
          Kindly be informed that there will be a scheduled maintenance
          activity which will temporarily interrupt your usage of the system.
        </p>

        <div
          style={{
            margin: "25px 0",
            padding: "20px",
            background: "#f8f9fa",
            borderRadius: "12px",
            border: "1px solid #ddd",
          }}
        >
          <p
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Maintenance Period
          </p>

          <p style={{ fontSize: "17px", margin: "5px" }}>
            <strong>Starts:</strong>{" "}
            {getSGTDate(maintenanceStart)} at 7:00 PM SGT
          </p>

          <p style={{ fontSize: "17px", margin: "5px" }}>
            <strong>Expected Availability:</strong>{" "}
            {getSGTDate(maintenanceEnd)} at 12:00 PM SGT
          </p>
        </div>

        <p
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          The system will be temporarily inaccessible during the
          above-mentioned period.
        </p>

        <p
          style={{
            fontSize: "16px",
            color: "#555",
            marginTop: "20px",
          }}
        >
          We apologize for the inconvenience and appreciate your patience
          and understanding.
        </p>

        <p
          style={{
            fontSize: "15px",
            color: "#555",
            marginTop: "25px",
          }}
        >
          For any system support enquiries, please contact your support team.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;